










































































import { defineComponent } from '@vue/composition-api';
import DownloadPath from '@/renderer/components/dialog/setting/components/components/DownloadPath.vue';
import { useTransmissionForm } from '@/renderer/components/dialog/setting/composition/useTransmissionForm';

// 下载设置
export default defineComponent({
  name: 'DownloadSetting',
  components: {
    DownloadPath,
  },
  setup(props) {
    const {
      transmissionMethods,
      defaultTransmissionSetting,
      isEqual,
      formRules,
      confirming,
      toggleMethods,
      speedDecimalPlaces,
      formData,
    } = useTransmissionForm('download');
    // 表单交互函数
    const formMethods = {
      onReset() {
        transmissionMethods.reset();
      },
    };

    return {
      speedDecimalPlaces,
      defaultTransmissionSetting,
      isEqual,
      confirming,
      formRules,
      formData,
      toggleMethods,
      formMethods,
      transmissionMethods,
    };
  },
});
